import { type EntityIdData } from "../../store/types";
import FundCard from "../FundCard";

export interface Props {
    funds: EntityIdData["funds"];
}

const FundCardList = ({ funds }: Props) => {
    return (
        <>
            {funds.map((id) => (
                <FundCard key={id} fund={id} />
            ))}
        </>
    );
};

export default FundCardList;
